
import Ugcs from "@/components/Ugcs.vue";
import { Component, Prop, Vue } from "vue-property-decorator";

@Component({
  components: { Ugcs },
})
export default class UgcContents extends Vue {
  @Prop() targetMemCd!: number;
  @Prop() ugcCd!: number;

  get ugcTypeCd() {
    switch (this.$route.name) {
      case "Reviews":
        return "047001";
      case "Feeds":
        return "047002";
      default:
        return "047011";
    }
  }
}
